import { ELocationType } from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { getDefaultVillageListRequest } from '../../interfaces/villages';
import { IThunkActionCreator } from '../../types/store';
import { geoUpdateCity, initHistoryState } from '../filters/actions';
import { saveFilters } from '../last_filters/actions';

export enum ActionTypes {
  FiltersOpened = 'FiltersOpened',
  FiltersCleared = 'FiltersCleared',
}

export interface IMobileFiltersOpened {
  type: ActionTypes.FiltersOpened;
  opened: boolean;
}

export interface IMobileFiltersCleared {
  type: ActionTypes.FiltersCleared;
  cleared: boolean;
}

export const onShowFiltersButton = (): IThunkActionCreator => dispatch => {
  dispatch(initHistoryState());
};

export const changeFiltersCleared = (cleared: boolean): IMobileFiltersCleared => ({
  type: ActionTypes.FiltersCleared,
  cleared,
});

export const clearFilters = (): IThunkActionCreator => (dispatch, getState) => {
  const {
    geo: { currentRegion },
  } = getState();

  dispatch(
    saveFilters({
      ...getDefaultVillageListRequest(),
      locationId: currentRegion ? currentRegion.id : 1,
      locationType: ELocationType.Location,
      regionId: currentRegion ? currentRegion.id : 1,
    }),
  );
  dispatch(geoUpdateCity(currentRegion));
  dispatch(changeFiltersCleared(true));
  /*
      После очистки фильтра и сброса стейтов компонентов на дефолтные,
      нужно актуализировать поле filtersCleared т.к. оно сигнализирует о моменте сброса
    */
  setTimeout(() => dispatch(changeFiltersCleared(false)));
};

export const changeFiltersOpened = (opened: boolean): IMobileFiltersOpened => ({
  opened,
  type: ActionTypes.FiltersOpened,
});

export const showMobileFilters =
  (opened = true): IThunkActionCreator =>
  dispatch => {
    dispatch(changeFiltersOpened(opened));
  };

export type Action = IMobileFiltersOpened | IMobileFiltersCleared;
